// src/pages/gt3x/Overview.jsx
import PageHero from "../../components/PageHero.jsx";

const people = [
    {
        area: "Ligaverantwortung & Orga",
        names: "Patrick Valente Ferro, Robin Fischer, Michael Kelnberger, Chris Geserer",
    },
    {
        area: "Orga",
        names: "Nail Hahn, Felix Teichgräber, Michael Müller, Philipp Gerdellebracht",
    },
    {
        area: "Kommunikation",
        names: "Patrick Valente Ferro",
    },
    {
        area: "Stream",
        names: "Michael Kelnberger",
    },
    {
        area: "Decals",
        names: "Michael Kelnberger, Felix Teichgräber",
    },
    {
        area: "Regelwerk",
        names: "Robin Fischer, Chris Geserer",
    },
    {
        area: "ReKo",
        names: "Leitung: Robin Fischer · Mitglieder: Thomas Kübler, Patrick Vester, Peer Dorn, Patrick Sitter, Felix Naumann, Benedikt Naumann",
    },
    {
        area: "Designer",
        names: "Felix Teichgräber",
    },
    {
        area: "Brand Ambassador",
        names: "Nail Hahn",
    },
    {
        area: "Webseite",
        names: "Chris Geserer",
    },
];

const formatRows = [
    {
        label: "Schedule",
        value: "iRacing GT-Sprint Serie über 12 Wochen. Je nach Season können auch passende IMSA-Strecken verwendet werden.",
    },
    {
        label: "Renndauer",
        value: "60 Minuten",
    },
    {
        label: "Qualifikation",
        value: "Open Qualifying",
    },
    {
        label: "Wertungen",
        value: "PRO, INT, AM, TEAM und eine inoffizielle Markenwertung.",
    },
    {
        label: "Streichergebnisse",
        value: "Drei Streichergebnisse über die Season.",
    },
    {
        label: "Tankbegrenzung",
        value: "60 %",
    },
    {
        label: "Wetter",
        value: "Möglichst identisch zu den offiziellen iRacing-Bedingungen. Ausnahme: Wenn iRacing eine Regenchance setzt, fahren wir bewusst ein Regenrennen. (maximal 2 pro Saison - Ansonsten nach Wahrscheinlichkeit der Serie)",
    },
    {
        label: "Fahrzeugklasse",
        value: "GT3",
    },
    {
        label: "Rennkommission",
        value: "Die Orga sichtet möglichst alle Incidents bereits vor. Die finale Beurteilung erfolgt durch die ReKo, damit nicht nur eingereichte Proteste bewertet werden.",
    },
    {
        label: "Warteliste",
        value: "Damit über die Season ein möglichst volles Starterfeld entsteht, führen wir eine Warteliste. Bei Abmeldungen können Wartelistenfahrer für einzelne Rennen nachrücken.",
    },
];

const weekDays = [
    {
        day: "Sonntag",
        badge: "Training",
        tone: "info",
        sessions: [
            ["Trainingsserver", "17:00 – 20:00 Uhr"],
            ["Practice", "2 Std. 30 Min"],
            ["Qualy", "15 Min"],
            ["Race", "15 Min"],
        ],
    },
    {
        day: "Montag",
        badge: "Training",
        tone: "info",
        sessions: [
            ["Trainingsserver", "18:00 – 21:00 Uhr"],
            ["Practice", "2 Std. 30 Min"],
            ["Qualy", "15 Min"],
            ["Race", "15 Min"],
        ],
    },
    {
        day: "Dienstag",
        subtitle: "Renntag",
        badge: "Race Day",
        tone: "warn",
        sessions: [
            ["Serverstart", "17:45 Uhr"],
            ["Practice", "17:45 – 19:10 Uhr"],
            ["Open Qualifying", "19:10 – 19:40 Uhr"],
            ["Warmup", "19:40 – 19:45 Uhr"],
            ["Race", "19:45 – 20:45 Uhr"],
        ],
    },
    {
        day: "Mittwoch",
        badge: "Afterview",
        tone: "ok",
        sessions: [
            ["Race Afterview", "~19:30 Uhr"],
            ["Hinweis", "siehe Discord Ankündigungen"],
        ],
    },
];

function TonePill({ children, tone = "info" }) {
    const cls =
        tone === "ok"
            ? "rv-status-pill rv-status-pill--ok"
            : tone === "warn"
                ? "rv-status-pill rv-status-pill--warn"
                : "rv-status-pill rv-status-pill--info";

    return <span className={cls}>{children}</span>;
}

function PersonCard({ area, names }) {
    return (
        <article className="rv-modern-card">
            <div className="rv-section-kicker">{area}</div>
            <p
                className="rv-modern-muted"
                style={{
                    margin: 0,
                    color: "var(--text)",
                }}
            >
                {names}
            </p>
        </article>
    );
}

function FormatRow({ label, value }) {
    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "minmax(130px, 185px) minmax(0, 1fr)",
                gap: 14,
                alignItems: "start",
                padding: "13px 0",
                borderBottom: "1px solid rgba(255,255,255,.07)",
            }}
        >
            <div
                style={{
                    color: "var(--accent)",
                    fontWeight: 900,
                    letterSpacing: ".04em",
                    textTransform: "uppercase",
                    fontSize: 13,
                    lineHeight: 1.35,
                }}
            >
                {label}
            </div>

            <div
                style={{
                    fontFamily: "var(--ff-Everett), sans-serif",
                    color: "var(--text)",
                    lineHeight: 1.55,
                    minWidth: 0,
                    whiteSpace: "normal",
                    overflowWrap: "anywhere",
                }}
            >
                {value}
            </div>
        </div>
    );
}

function DayCard({ day, subtitle, badge, tone, sessions }) {
    return (
        <article className="rv-modern-card rv-modern-card--accent">
            <div className="rv-section-head" style={{ marginBottom: 10 }}>
                <div>
                    <div className="rv-section-kicker">
                        {subtitle || "Training"}
                    </div>

                    <h3
                        style={{
                            fontSize: 26,
                            margin: 0,
                            lineHeight: 1,
                        }}
                    >
                        {day}
                    </h3>
                </div>

                <TonePill tone={tone}>{badge}</TonePill>
            </div>

            <div
                style={{
                    display: "grid",
                    gap: 7,
                    marginTop: 14,
                }}
            >
                {sessions.map(([session, time]) => (
                    <div
                        key={`${day}-${session}`}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "minmax(0, 1fr) auto",
                            gap: 10,
                            alignItems: "center",
                            padding: "8px 10px",
                            borderRadius: 12,
                            background: "rgba(255,255,255,.035)",
                            border: "1px solid rgba(255,255,255,.065)",
                        }}
                    >
                        <div
                            style={{
                                minWidth: 0,
                                fontWeight:
                                    session === "Trainingsserver" ||
                                    session === "Serverstart" ||
                                    session === "Race" ||
                                    session === "Race Afterview"
                                        ? 900
                                        : 600,
                                lineHeight: 1.25,
                            }}
                        >
                            {session}
                        </div>

                        <div
                            style={{
                                fontFamily: "var(--ff-Everett), sans-serif",
                                color: "var(--muted)",
                                textAlign: "right",
                                whiteSpace: "normal",
                                lineHeight: 1.25,
                                fontSize: 14,
                            }}
                        >
                            {time}
                        </div>
                    </div>
                ))}
            </div>
        </article>
    );
}

export default function Overview() {
    return (
        <div className="rv-page">
            <PageHero
                kicker="GT3 Xperience"
                title="Overview"
            >
                Willkommen in unserer iRacing GT3 Xperience. Hier findest du die wichtigsten Ansprechpartner,
                das Ligaformat und den kompakten Wochenablauf rund um den Renntag.
            </PageHero>

            <section className="rv-modern-card">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Organisation</div>
                        <h2>Verantwortliche Personen</h2>
                    </div>

                    <TonePill tone="info">RaceVision Team</TonePill>
                </div>

                <div
                    className="rv-modern-grid"
                    style={{
                        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
                    }}
                >
                    {people.map((item) => (
                        <PersonCard
                            key={item.area}
                            area={item.area}
                            names={item.names}
                        />
                    ))}
                </div>
            </section>

            <section className="rv-modern-card rv-modern-card--accent">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">League Format</div>
                        <h2>Liga Format</h2>
                    </div>

                    <div className="rv-pill-row">
                        <TonePill tone="warn">GT3</TonePill>
                        <TonePill tone="info">PRO / INT / AM</TonePill>
                    </div>
                </div>

                <div
                    style={{
                        display: "grid",
                        gap: 0,
                        marginTop: 4,
                    }}
                >
                    {formatRows.map((row) => (
                        <FormatRow
                            key={row.label}
                            label={row.label}
                            value={row.value}
                        />
                    ))}
                </div>
            </section>

            <section className="rv-modern-card">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Race Week</div>
                        <h2>Wochenüberblick</h2>
                    </div>

                    <TonePill tone="ok">Sonntag bis Mittwoch</TonePill>
                </div>

                <p
                    className="rv-modern-muted"
                    style={{
                        marginTop: 0,
                        marginBottom: 16,
                    }}
                >
                    Die Woche ist bewusst kompakt aufgebaut: Trainingsserver am Sonntag und Montag,
                    Rennen am Dienstag und die gemeinsame Nachbesprechung am Mittwoch.
                </p>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: 14,
                    }}
                >
                    {weekDays.map((item) => (
                        <DayCard
                            key={item.day}
                            day={item.day}
                            subtitle={item.subtitle}
                            badge={item.badge}
                            tone={item.tone}
                            sessions={item.sessions}
                        />
                    ))}
                </div>

                <style>
                    {`
                        @media (max-width: 900px) {
                            .rv-page section:last-child > div:last-child {
                                grid-template-columns: 1fr !important;
                            }
                        }

                        @media (max-width: 650px) {
                            .rv-page [style*="grid-template-columns: minmax(130px, 185px)"] {
                                grid-template-columns: 1fr !important;
                                gap: 4px !important;
                            }
                        }
                    `}
                </style>
            </section>
        </div>
    );
}